import { useForm } from 'react-hook-form'
import { signInResolver } from 'resolvers'
import { IFormInput } from './sign-in-patient-group-types'

function useFormSignIn() {
  const { control, handleSubmit, watch } = useForm<IFormInput>({
    mode: 'onBlur',
    resolver: signInResolver,
    defaultValues: {
      cpf: '',
      password: '',
    },
  })

  return { control, handleSubmit, watch }
}

export default useFormSignIn
